export default function Dropdown({
  text,
  data,
  setValue,
  defaultSelectedValue,
}) {
  return (
    <div className="form-group">
      <label className="form-label">{text}</label>
      <select
        className="form-control dropdown"
        placeholder="Select"
        onChange={(e) => setValue(e.target.value)}>
        {data &&
          Object.entries(data).map(([key, value]) => {
            return (
              <option
                value={value.id}
                key={key}
                selected={
                  defaultSelectedValue &&
                  Number(value.id) === Number(defaultSelectedValue)
                }>
                {value.fullName}
                {value.text}
              </option>
            );
          })}
      </select>
    </div>
  );
}
